import React from 'react';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import RecordsScreen from '/component/layout/RecordsScreen';
import {CLIENT_REPORT} from '/enum/popover.enum';
import {REPORT_CARD_CONTENT_PREMIER_CANCELLATIONS} from '/enum/reportCard.enum';
import {withTranslation} from '/provider/TranslationProvider';
import {variablesFeatureFlag} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';
import {withHOC} from '/util/hoc.util';

import {ReportProps} from '../Report.types';
import withRecordPopover from '../withRecordPopover';

import {PremierCancellationsContent} from './PremierCancellationsContent';
import reportPayload from './reportPayload';

export const PremierCancellationsReport = ({
  loadingData = {total: 0},
  tt = (key: string, defaultValue?: string) => defaultValue || '',
  showRecordPopover = () => {},
}: ReportProps) => {
  const featureFlag = useSelector(variablesFeatureFlag);
  const updatePremierPlus = shouldReleaseFeature(
    get(featureFlag, 'ff_Premier_Plus', ''),
  );
  const premierValue = updatePremierPlus ? 'Premier+' : 'Premier';

  return (
    <RecordsScreen
      {...reportPayload}
      title={tt('title', `${premierValue} Cancellations`)}
      description={tt(
        'description',
        `These Clients have cancelled their ${premierValue} orders in the last month. Why not reach out to see how they are doing and if they need anything?`,
      )}
      contentProps={{loadingData, showRecordPopover}}
      contentComponent={PremierCancellationsContent}
    />
  );
};

export default withHOC(
  withTranslation('report.premierCancellations'),
  withRecordPopover({
    reportPayload,
    popoverName: CLIENT_REPORT,
    popoverContentName: REPORT_CARD_CONTENT_PREMIER_CANCELLATIONS,
    popoverContentProps: {},
  }),
)(PremierCancellationsReport);
